import React, { useEffect } from 'react';
import { App } from './webGL/Opengl';
import './../pg/Global.css';
import './Palette.css';
import './InfoBanner.css';

type InfoBannerParms = {
    title: string,
    how_to: string,
};

var app = new App();

const InfoBanner: React.FC<InfoBannerParms> = ({ title, how_to }) => {
    useEffect(() => {
        app.Init();
        app.RunStart();
        return () => {
            app.Dispose();
        };
    });

    return (
        <div className='BannerWrapper'>
            <div id='navSpacer' />
            <div id='BannerArea'>
                <div id='BannerBackground' />
                <div id='BannerWrapForeground'>
                    <div id='BannerTextWrap'>
                        <h1 id='BannerText'>
                            1mB33
                        </h1>
                        <div id='BannerSpacerSmol' />
                        <div id='BannerTextSub'>
                            {title}
                        </div>
                    </div>
                    <div id='BannerControlInfo'>
                        <a>
                            {how_to}
                        </a>
                    </div>
                </div>
                <canvas id='BannerCanvas'> </canvas>
            </div>
            <div id='BannerSpacer' />
        </div>
    );
};

export default InfoBanner;
